// Backend-keuze per tenant. Schakelen mock⇄echt gebeurt via VITE_USE_MOCK_AUTH;
// beide paden krijgen per tenant een eigen instantie (gememoized), zodat de
// tenantkeuze uit het loginscherm ook in mock-modus de juiste gebruiker oplevert.
import { createMockAuth } from './mockAuth';
import { createMsalAuth } from './msalAuth';
import { getSelectedTenant } from './selectedTenant';
import type { TenantCode } from './tenants';
import type { AuthBackend } from './types';

const useMockBackend = import.meta.env.VITE_USE_MOCK_AUTH === 'true';

const backends = new Map<TenantCode, AuthBackend>();

export function getBackend(code: TenantCode): AuthBackend {
  let backend = backends.get(code);
  if (!backend) {
    backend = useMockBackend ? createMockAuth(code) : createMsalAuth(code);
    backends.set(code, backend);
  }
  return backend;
}

/**
 * Backend voor de actieve sessie (op basis van de opgeslagen tenantkeuze).
 * `null` wanneer er geen tenant gekozen is — er is dan geen actieve sessie.
 */
export function getActiveBackend(): AuthBackend | null {
  const code = getSelectedTenant();
  return code ? getBackend(code) : null;
}
